import styled from "styled-components"
import React from "react"
import {
    Input,
    AngleDownIcon,
} from "client/components"

export const RenameInput = styled(Input)<{
    blockView: boolean
    listView: boolean
}>`
    ${(props) => props.blockView && `
        position: absolute;
        bottom: 0;
        width: calc(100% - 16px);
        margin: 6px 8px;
    `}

    ${(props) => props.listView && `
        position: absolute;
        width: calc(100% - 12px * 2);
        top: 50%;
        transform: translateY(-50%);
    `}

    height: 24px;
    font-size: 13px;
    background: ${(props) => props.theme.driveRenameInputBackgroundColor};
    color: black;
    padding: 5px 7px;
    z-index: 1;

    &:focus {
        color: ${(props) => props.theme.driveRenameInputColor};
    }
`

const FolderCollapseWrapper = styled.div<React.HTMLAttributes<HTMLDivElement>>`
    position: absolute;
    left: -16px;
    top: 4px;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 16px;
    height: 16px;
    color: ${(props) => props.theme.driveMoveToCollapseColor};
    transform: rotate(0);
    transition: ${(props) => props.theme.defaultTransition};
`
export const FolderCollapseControl = (props: React.HTMLAttributes<HTMLDivElement>) => (
    <FolderCollapseWrapper {...props}>
        <AngleDownIcon />
    </FolderCollapseWrapper>
)

export const FolderListContent = styled.div`
    padding: 20px;
    min-height: 150px;
    overflow-y: auto;
    background: ${(props) => props.theme.driveMoveToBackground};
`
export const FolderListWrapper = styled.div`
    overflow: hidden;
    padding-left: 20px;
`
export const Folder = styled.div<{
    selected: boolean
    inactive: boolean
}>`
    position: relative;
    display: flex;
    cursor: pointer;
    user-select: none;
    padding: 2px 8px;
    opacity: ${(props) => (props.inactive ? 0.5 : 1)};
    pointer-events: ${(props) => (props.inactive ? "none" : "all")};
    background: ${(props) => (props.selected ? props.theme.driveMoveToSelectedBackground : "transparent")};
    color: ${(props) => (props.selected ? props.theme.driveMoveToSelectedColor : "inherit")};
`
export const FolderWrapper = styled.div`
    &.collapsed {
        & > ${FolderListWrapper} {
            height: 0;
        }

        & > ${Folder} > ${FolderCollapseWrapper} {
            transform: rotate(-90deg);
        }
    }
`
export const FolderImage = styled.img`
    width: 16px;
    margin-right: 10px;
`
export const FolderTitle = styled.div`
`
